module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/extension-worker/extension-worker.ff8471dee61075fad4f7.js");
};